import { jsx as _jsx } from "react/jsx-runtime";
/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './style.css';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { persistedAppStore, store } from './core/AppStore';
ReactDOM.createRoot(document.getElementById('root')).render(_jsx(React.StrictMode, { children: _jsx(Provider, { store: store, children: _jsx(PersistGate, { persistor: persistedAppStore, children: _jsx(App, {}) }) }) }));
